import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { colors } from '../../../../../colorVars';
import CloseWindowButton from '../../../../atomic/buttons/closeWindow/CloseWindowButton';
import { Body2, fontSizes } from '../../../../atomic/text/Text';
import style from './AlertWatchlistComponent.module.css';
import { AlertWatchlistComponentControls } from './alertWatchlistComponentControls/AlertWatchlistComponentControls';
import { AlertWatchlistComponentTableBody } from './alertWatchlistComponentTableBody/AlertWatchlistComponentTableBody';
import { AlertWatchlistComponentHeader } from './alertWatchlistHeader/AlertWatchlistComponentHeader';
import { groupNumberMap } from './groupNumberMap';
import { useAlertWatchlistComponent } from './utils/useAlertWatchlistComponent';

export const AlertWatchlistComponent = observer(
  ({ details, moduleId, layoutType }) => {
    const groupNumber = details?.groupNumber || 0;
    const removeModule = () => {
      layoutStore.removeModuleFromCurrentLayout(layoutType, moduleId);
    };
    const parentNodeRef = useRef(null);
    const {
      selectedWatchlist,
      setSelectedWatchlist,
      selectedAlert,
      setSelectedAlert,
      alertStore,
      layoutStore,
    } = useAlertWatchlistComponent(details, moduleId);
    const watchlistNames = alertStore.listOfWatchlistNames;
    return (
      <div
        className={style.container}
        ref={parentNodeRef}
        onClick={() => layoutStore.setCurrentFocusedModule(moduleId)}
      >
        <header className={style.header}>
          <div className={style.group}>
            <Body2 margin="0 5px 0 0" color={colors.lightGrey} fontWeight={700}>
              Alerts
            </Body2>
            <select
              value={groupNumber}
              onChange={({ target }) => {
                layoutStore.updateCurrentLayoutModuleGroupNumber(
                  'alerts',
                  moduleId,
                  target.value
                );
                layoutStore.updateServerCurrentLayout(
                  'alerts',
                  'currentAlerts'
                );
              }}
              className={style.groupSelect}
              style={{
                backgroundColor: groupNumberMap[groupNumber].color,
                color: groupNumber === '6' ? colors.black : colors.lightGrey,
                border: 'none',
                fontSize: fontSizes.body4,
                fontWeight: 700,
              }}
            >
              {groupNumberMap.map(({ value, label, color }) => (
                <option
                  key={value}
                  value={value}
                  style={{ backgroundColor: color }}
                >
                  {label}
                </option>
              ))}
            </select>
          </div>
          <select
            style={{ fontSize: fontSizes.body2 }}
            className={style.select}
            value={selectedWatchlist}
            onChange={({ target }) => setSelectedWatchlist(target.value)}
          >
            <option value="default">Select a watchlist...</option>
            {watchlistNames.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
          <CloseWindowButton
            width={15}
            stroke={2}
            color={colors.red}
            handleClick={removeModule}
          />
        </header>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <AlertWatchlistComponentHeader />
            <AlertWatchlistComponentTableBody
              layoutStore={layoutStore}
              moduleId={moduleId}
              parentNode={parentNodeRef}
              watchlistName={selectedWatchlist}
              selectedAlert={selectedAlert}
              setSelectedAlert={setSelectedAlert}
            />
          </table>
        </div>
        <AlertWatchlistComponentControls selectedAlert={selectedAlert} selectedWatchlist={selectedWatchlist} />
      </div>
    );
  }
);

AlertWatchlistComponent.propTypes = {
  details: PropTypes.shape({
    watchlistName: PropTypes.any,
  }),
};
